<template>
  <div ref="staffIndex">
    <!-- 查询区域 -->
    <section class="select" style="minwidth: 800px">
      <div>
        <!-- <span>员工姓名：</span> -->
        <Input v-model="selectData.name" :placeholder="$t('staff.list')"></Input>
      </div>
      <div>
        <!-- <span>联系电话：</span> -->
        <Input v-model="selectData.mobile" :placeholder="$t('staff.Phone')"></Input>
      </div>
      <div>
        <!-- <span>状态：</span> -->
        <Select
          v-model="selectData.office"
          style="width: 160px"
          :placeholder="$t('staff.status')"
        >
          <Option value="1"> {{$t('staff.working')}}</Option>
          <Option value="0"> {{$t('staff.Resign')}}</Option>
        </Select>
      </div>
      <div>
        <!-- <span>状态：</span> -->
        <Select
          v-model="selectData.status"
          style="width: 160px"
          :placeholder="$t('staff.Account')"
        >
          <Option value="0"> {{$t('staff.enable')}}</Option>
          <Option value="1"> {{$t('staff.Disable')}}</Option>
        </Select>
      </div>

      <div>
        <Button type="primary" @click="selectStaff" :loading="selectLoading">
          {{$t('staff.search')}}</Button
        >
        <Button @click="resetStaff" style="color: #fff; margin-left: 10px"
          >{{$t('staff.reset')}}</Button
        >
      </div>
    </section>
    <div class="among">
      <!-- 文字描述区域 -->
      <div class="textArea" style="minwidth: 600px">
        <Button type="primary" @click="setStaff" v-has="'WSS-6001-create'"
          >{{$t('staff.Add')}}</Button
        >
        <Button
          type="primary"
          @click="editEvent"
          class="btns"
          v-has="'WSS-6001-edit'"
          >{{$t('staff.Revise')}}</Button
        >
        <Button type="primary" @click="editIffoice">{{ text=='离职' ? $t('staff.Resign') : $t('staff.working')}}</Button>
        <Button
          type="primary"
          @click="editStatus"
          class="btns"
          v-has="'WSS-6001-switchstatus'"
          >{{ text1=='关闭'? $t('staff.Disable') : $t('staff.enable') }} {{$t('personal.account')}}</Button
        >
        <Button type="primary" @click="resetPWD" v-has="'WSS-6001-repassword'"
          >{{$t('staff.Password')}}</Button
        >
        <div v-if="staffDesc">
          {{$t('staff.Number')}}<span>{{ staffNum.created }}</span
          >{{$t('staff.bit')}}, {{$t('staff.also')}}<span>{{ staffNum.addable }}</span
          >{{$t('staff.bit')}}
        </div>
        <!-- <div><span>购买套餐/联系客服</span>提升员工数量上限</div> -->
      </div>
      <!-- 表格主体 -->
      <vxe-table
        border
        :max-height="screenHeight"
        show-header-overflow
        show-overflow
        highlight-hover-row
        align="center"
        ref="xTable1"
        :loading="tableLoading"
        :data="tableData"
        @radio-change="radioChangeEvent"
        style="width: 98%"
      >
        <vxe-column minWidth="80" type="radio" :title="$t('staff.choose')"></vxe-column>
        <vxe-column minWidth="100" field="staffName" :title="$t('staff.name')"></vxe-column>
        <vxe-column minWidth="80" field="genderName" :title="$t('staff.gender')"></vxe-column>
        <vxe-column minWidth="150" field="mobile" :title="$t('staff.phoneNumber')"></vxe-column>
        <vxe-column minWidth="100" field="roleName" :title="$t('staff.Role')"> </vxe-column>
        <vxe-column minWidth="100" field="inOfficeName" :title="$t('staff.status')">
        </vxe-column>
        <vxe-column minWidth="100" field="statusName" :title="$t('staff.Account')">
        </vxe-column>
<!--        <vxe-column minWidth="150" field="createUname" title="创建信息">-->
<!--          <template #default="{ row }">-->
<!--            <div>{{ row.createUname == null ? '暂无' : row.createUname }}</div>-->
<!--            <div>{{ row.createTime }}</div>-->
<!--          </template>-->
<!--        </vxe-column>-->
<!--        <vxe-column minWidth="150" field="createTime" title="编辑信息">-->
<!--          <template #default="{ row }">-->
<!--            <div>{{ row.updateUname }}</div>-->
<!--            <div>{{ row.updateTime }}</div>-->
<!--          </template></vxe-column-->
<!--        >-->
      </vxe-table>
      <!-- 分页 -->
      <div style="minwidth: 600px; margin-right: 1.7%">
        <div style="display: flex; justify-content: right; padding-right: 5px">
          <vxe-pager
            background
            align="right "
            size="medium"
            :current-page.sync="pager.current"
            :page-size.sync="pager.size"
            :page-sizes="[30]"
            :total="pager.total"
            @page-change="handlePageChange"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'Number',
              'NextPage',
              'NextJump',
              'Sizes',
              'FullJump',
              'Total'
            ]"
          >
          </vxe-pager>
          <span
            style="
              height: 31px;
              padding: 7px 10px;
              border: 1px solid rgb(220, 222, 226);
              border-radius: 4px;
              margin-top: 8px;
              line-height: 13px;
            "
            >30条/页</span
          >
        </div>
        <!-- <vxe-pager
          background
          align="right "
          size="medium"
          :current-page.sync="pager.current"
          :page-size.sync="pager.size"
          :page-sizes="[30]"
          :total="pager.total"
          @page-change="handlePageChange"
          :layouts="[
            'PrevJump',
            'PrevPage',
            'Number',
            'NextPage',
            'NextJump',
            'Sizes',
            'FullJump',
            'Total'
          ]"
        >
          >
        </vxe-pager> -->
      </div>
    </div>
    <!-- 模态框 -->
    <setstaff-model :statusList="statusList" ref="setModel"></setstaff-model>
    <updatestaff-model ref="updateModel"></updatestaff-model>
    <Modal v-model="Modeloffice" title="提示" :mask-closable="false">
      <p>确认{{ text1 }}下方员工账号吗？</p>
      <p>姓名：{{ this.val.staffName }}</p>
      <p>手机号：{{ this.val.mobile }}</p>
      <div slot="footer" class="footer">
        <Button type="error" :loading="delLoading" @click="delSave()"
          >确定</Button
        >
        <Button
          type="default"
          @click="delCancel()"
          style="background: #fff; color: #377cf1"
          >取消</Button
        >
      </div>
    </Modal>
    <Modal v-model="Modelpwd" title="提示" :mask-closable="false" class="yy">
      <p>确认重置下方员工账号密码？</p>
      <p>姓名：{{ this.val.staffName }}</p>
      <p>手机号：{{ this.val.mobile }}</p>
      <div slot="footer" class="footer">
        <Button type="error" :loading="pwdLoading" @click="btnOK()"
          >确定</Button
        >
        <Button
          type="default"
          @click="btnCancel()"
          style="background: #fff; color: #377cf1"
          >取消</Button
        >
      </div>
    </Modal>
    <!-- <Modal v-model="delModel" title="删除" :mask-closable="false">
      确认删除该员工？
      <div slot="footer" class="footer">
        <Button type="error" :loading="delLoading" @click="delSave()"
          >确定</Button
        >
        <Button type="default" @click="delCancel()">取消</Button>
      </div>
    </Modal> -->
  </div>
</template>

<script>
import {
  getStaffList,
  getinoffice,
  getstatus,
  editPWD,
  getNum
} from '@/api/myweb/organization/staffManagement'
import { getStatusList } from '@/api/myweb/organization/linkmanManagement'

import setstaffModel from './components/setstaffModel.vue'
import updatestaffModel from './components/updatestaffModel.vue'

export default {
  components: { setstaffModel, updatestaffModel },
  data() {
    return {
      pwdLoading: false,
      Modelpwd: false,
      val: {},
      Modeloffice: false,
      text: '离职',
      text1: '关闭',
      value: '',
      delModel: false,
      delLoading: false,
      delDataId: '',
      selectLoading: false,
      tableLoading: true,
      isAddBtn: false,
      screenHeight: '',
      // setModelData: {}, // 新增模态框数据
      updateModelData: {}, // 修改模态框数据
      pager: {
        current: 1,
        size: 30,
        total: 0
      },
      staffDesc: true,
      staffNum: {
        // max: 0,
        // min: 0
      },
      selectData: {
        name: '',
        mobile: '',
        status: '',
        office: ''
      },
      statusList: [],
      selectObj: {
        name: '',
        mobile: '',
        status: '-1',
        office: '-1'
      },
      tableData: []
    }
  },
  created() {
    this.getStaffList()
  },
  mounted() {
    this.screenHeight = document.body.clientHeight > 800 ? 620 : 440
    window.onresize = () => {
      return (() => {
        this.screenHeight = document.body.clientHeight > 800 ? 620 : 440
      })()
    }
    console.log(this.screenHeight)
  },
  methods: {
    // 初始化列表
    async getStaffList() {
      this.tableLoading = true
      let data = {
        name: this.selectObj.name,
        mobile: this.selectObj.mobile,
        status: this.selectObj.status,
        office: this.selectObj.office,
        current: this.pager.current,
        size: this.pager.size
      }
      console.log(data)
      let res = await getStaffList(data)
      console.log(res)
      this.selectLoading = false
      if (res.status) {
        this.tableData = res.data.records
        this.pager.total = res.data.total
        this.getNum()
        // console.log(this.tableData)
      } else {
      }
      this.tableLoading = false
    },
    // 获取可添加员工数量
    async getNum() {
      const res = await getNum()
      console.log(res)
      if (res.status) {
        this.staffNum = res.data
      }
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.pager.current = currentPage
      this.pager.size = pageSize
      console.log(currentPage, pageSize)
      this.getStaffList()
    },
    // 按钮
    selectStaff() {
      this.selectObj = JSON.parse(JSON.stringify(this.selectData))
      this.selectLoading = true
      this.getStaffList()
    },
    resetStaff() {
      this.selectData = {
        staffName: '',
        phone: '',
        status: '',
        office: ''
      }
      this.selectObj = { name: '', mobile: '', status: '-1', office: '-1' }
      this.getStaffList()
    },
    // 新增员工
    setStaff() {
      this.$refs.setModel.getData()
    },
    // 修改员工
    async editEvent() {
      if (this.$refs.xTable1.getRadioRecord() == null) {
        this.$Message.warning('请您选择一位员工')
      } else {
        this.$refs.updateModel.getData(this.$refs.xTable1.getRadioRecord())
      }
    },
    // 离职/复工员工
    radioChangeEvent({ row }) {
      console.log(row)
      if (this.$refs.xTable1.getRadioRecord() == null) {
        this.$Message.warning('请您选择一位员工')
      } else {
        this.val = JSON.parse(JSON.stringify(row))
        if (row.inOffice == 1) {
          this.text = '离职'
        } else {
          this.text = '在职'
        }
        if (row.status) {
          this.text1 = '启用'
        } else {
          this.text1 = '关闭'
        }
        console.log(this.text1)
      }
    },
    // 改员工状态
    async editIffoice() {
      if (this.$refs.xTable1.getRadioRecord() == null) {
        this.$Message.warning('请您选择一位员工')
      } else {
        const res = await getinoffice({
          id: this.val.id
        })
        if (res.status) {
          this.$Message.success('操作成功！')
          this.getStaffList()
        }
      }
    },
    // 关闭账号
    editStatus() {
      if (this.$refs.xTable1.getRadioRecord() == null) {
        this.$Message.warning('请您选择一位员工')
      } else {
        if (this.$refs.xTable1.getRadioRecord().inOffice) {
          this.Modeloffice = true
        } else {
          this.$Message.warning('该员工已离职，不可操作')
        }
      }
    },
    async delSave() {
      this.delLoading = true
      let res = await getstatus({
        id: this.val.id
      })
      console.log(res)
      if (res.status) {
        this.Modeloffice = false
        this.$Message.success('操作成功！')
        this.getStaffList()
      }
      this.delLoading = false
    },
    delCancel() {
      this.Modeloffice = false
      // this.delModel = false
    },
    // 重置密码
    resetPWD() {
      if (this.$refs.xTable1.getRadioRecord() == null) {
        this.$Message.warning('请您选择一位员工')
      } else {
        this.Modelpwd = true
      }
    },
    async btnOK() {
      this.pwdLoading = true
      let res = await editPWD({
        id: this.val.id
      })
      if (res.status) {
        this.Modelpwd = false
        this.$Message.success('操作成功！')
        this.getStaffList()
      }
      this.pwdLoading = false
    },
    btnCancel() {
      this.Modelpwd = false
    }
    // 删除员工
    // delEvent(row) {
    //   this.delDataId = row.id
    //   console.log(this.delDataId)
    //   this.delModel = true
    // },

    // handlePageChange({ currentPage, pageSize }) {
    //   this.pager.currentPage = currentPage
    //   this.pager.pageSize = pageSize
    //   this.getStaffList()
    // }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
